{
  "id": "icons-more",
  "class": "icon",
  "size": {
    "w": 16,
    "h": 16
  },
  "anchor": {
    "x": 8,
    "y": 8
  },
  "palette": {
    "k": "#23140b",
    "g": "#6a9a3f",
    "G": "#97c25a",
    "e": "#46702f",
    "y": "#e6b832",
    "Y": "#f7d969",
    "d": "#be7934",
    "n": "#d6d0c6",
    "N": "#aaa399",
    "E": "#7a736b",
    "W": "#f5f1e8",
    "c": "#dcc096",
    "C": "#efe0c2",
    "s": "#b89062",
    "b": "#4a78b0",
    "B": "#7aa8d8",
    "u": "#2c4a7a"
  },
  "frames": {
    "friends": [
      "................",
      "..........kkkk..",
      ".........knnnNk.",
      ".........knnNNk.",
      ".........knNNEk.",
      ".........kkkkk..",
      "...kkkk.knnNNEk.",
      "..kBBbbknnnnNNEk",
      "..kBbbbknnnNNEEk",
      "..kbbbuknnNNEEEk",
      "..kkkkkkkkNNEEkk",
      ".kBBBBbbuukkkkkk",
      ".kBBBBbbbuuuk...",
      ".kBBBbbbbbuuuk..",
      ".kBBbbbbbbuuuuk.",
      ".kkkkkkkkkkkkkk."
    ],
    "shop": [
      "................",
      ".....kkkkkk.....",
      ".....k....k.....",
      ".....k....k.....",
      "..kkkkkkkkkkkk..",
      "..kGGGGggggeek..",
      "..kGGGGggggeek..",
      "..kGGgyyygeekk..",
      "..kGGyyyyyeekk..",
      "..kGGgddygeekk..",
      "..kGGggggggeek..",
      "..kGgggggggeek..",
      "..kkkkkkkkkkkk..",
      "................",
      "................",
      "................"
    ],
    "settings": [
      "................",
      "......kkkk......",
      "..kk..knnk..kk..",
      ".knnkkkNNkkknnk.",
      ".knNNNNNNNNNNnk.",
      "..kNNNkkkkNNNk..",
      ".knNNkkkkkkNNek.",
      ".knNNkkkkkkNNek.",
      "..kNNNkkkkNNEk..",
      ".knNNNNNNEEENEk.",
      ".kEEkkkEEEkkkEk.",
      "..kk..kEEk..kk..",
      "......kkkk......",
      "................",
      "................",
      "................"
    ],
    "save": [
      "................",
      "..kkkkkkkkkk....",
      "..kNNnnkkNNkk...",
      "..kNNnnkkNNNk...",
      "..kNNnnkkNNNk...",
      "..kbbbbbbbbuk...",
      "..kCCCCCCCCuk...",
      "..kCccccccsuk...",
      "..kCccccccsuk...",
      "..kCccccccsuk...",
      "..kbbbbbbbuuk...",
      "..kkkkkkkkkkk...",
      "................",
      "................",
      "................",
      "................"
    ]
  }
}
